<div class="dialog-padding">
  <h1 mat-dialog-title>Fare Review Notes</h1>
  <app-trip-notes-detail [customerServiceNotes]="data.fareReviewNotes | async" (addNote)="handleCreateNote($event)"></app-trip-notes-detail>
  <div mat-dialog-actions align="end">
    <button mat-button (click)="handleCloseDialog()">Close</button>
  </div>
</div>
